import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';
import { Service } from '../service';
import { ReportConfiguration } from '../../models/report-configuration/report-configuration';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ReportConfigurationService extends Service {
    constructor(
        private http: HttpClientService
    ) {
        super();
    }

    public get(): Observable<ReportConfiguration> {
        const url = 'reportconfiguration';
        return this.http.get(url).map(response => {
            const r = response.json();
            let result = new ReportConfiguration();
            if (r.ResultCode === 1) {
                result = r.Result;
            } else {
                console.error('ReportConfigurationService > get > response', r);
            }
            return result;
        }).catch(this.handleError);
    }

    public edit(reportConfiguration: ReportConfiguration) {
        const url = 'reportconfiguration';
        return this.http.post(url, reportConfiguration).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/report-configuration/report-configuration.service.ts